import React from 'react';

function PromoCodeStatusMessageTemplate ({ modelAttributes }) {

	const { promoCodeError, SelectedPromoCode } = modelAttributes;

	if (SelectedPromoCode) {

		if (promoCodeError) {

			return (
				<>
					<span className="upperCase">Invalid Code: </span>
					{SelectedPromoCode}
				</>
			);

		}
		return (
			<>
				<span className="upperCase">Applied Code: </span>
				{SelectedPromoCode}
			</>
		);

	}

	return null;

}

export default PromoCodeStatusMessageTemplate;
